import React from "react";
import Explainer from "../ExplainerModal";

const ProfileInformationExplainer = () => {
  return (
    <Explainer
      title="👤 Profile Information Explainer"
      content={
        <>
          <p>
            The <strong>Profile Information</strong> section provides an overview of your personal and organizational details. Users can view and update key metadata to ensure their information remains accurate and up to date.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            🔍 Profile Details
          </h3>
          <ul>
            <li>📛 <strong>Name:</strong> Your full name as registered on the platform.</li>
            <li>🏢 <strong>Organization:</strong> The institution or entity you are affiliated with.</li>
            <li>📧 <strong>Email:</strong> Your registered email address for communication.</li>
            <li>📍 <strong>Location:</strong> Your country or region of operation.</li>
            <li>🔑 <strong>Access Level:</strong> Defines your permissions on the platform.</li>
            <li>✅ <strong>Status:</strong> Indicates whether your account is active or inactive.</li>
          </ul>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            ✏️ Editing Your Profile
          </h3>
          <p>
            Users can update their profile metadata by clicking on the edit buttons.
          </p>
        </>
      }
    />
  );
};

export default ProfileInformationExplainer;
